export const APPLICATION_NAME = 'My Account Fido';
export const MYACCOUNT_APPID = 'myaccount';
export const GENESIS = 'genesis';
export const MSERVICES = 'mservices';

// Cookies key
export const COOKIES_PAGE_USER_NAME = 'pageUserName';
export const COOKIES_USER_INFO = 'userInfo';
export const COOKIE_LOGGED_IN = 'loggedIn';

// external links
export const LINK_ACCOUNT_URL = 'link-account';
export const CONTACT_US_URL = '/consumer/contact-us';
export const FIND_A_STORE_URL = '/stores/';
export const AAL_PHONE_PLANS_URL = '/add-a-line/phone-plans';
export const AAL_PHONES_URL = '/phones/?flowType=aal';
export const HUP_FLOW_URL = '/phones?flowType=hup#/choose-phone';
export const PPC_FLOW_URL = '/phones/build-plan?flowType=ppc';
export const MANAGE_ADDONS_URL = '/phones/manage-addons';
export const WCOC_MANAGE_USERS_URL = '/wcoc/manage-users';

// Modal Triggers
export const AUTOPAY_PROMO_MODAL = 'show-autopay-promo-modal';
export const UPDATE_CREDIT_CARD_MODAL = 'show-update-credit-card-modal';
export const SHOW_PAY_THROUGH_BANK = 'show-pay-though-bank';
export const SHOW_PROMISE_TO_PAY_INSTALLMENTS = 'show-promise-to-pay-installments';

// Routes
export const OVERVIEW_ROUTE = 'overview';
export const MAINTENANCE_ROUTE = 'maintenance';
export const WIRELESS_ROUTE = 'wireless';
export const TEMPORARY_SUSPENSION_ROUTE = 'temporary-suspension';
export const DATA_MANAGEMENT_ROUTE = 'manage-data';
export const PTP_URL = 'promise-to-pay';
export const REPORT_PAYMENT_URL = 'report-payment';
export const CHANGE_PAYMENT_METHOD_URL = 'payments/auto';
export const PAYMENT_URL = 'payments/pay';
export const PAYMENT_HISTORY_URL = 'payments/history';
export const ROGERS_BANK_ROUTE = 'rogers-bank';
export const ACCESSORIES_ROUTE = 'financed-accessories';
export const VIEW_BILL_URL = 'view-bill';
export const CHANGE_PHONE_NUMBER_ROUTE = '/change-phone-number';
export const CHANGE_PHONE_NUMBER_ERROR_ROUTE = '/change-phone-number/error';
export const PORT_IN_ROUTE = '/transfer-phone-number';
export const TEMPORARY_SUSPENSION_TERMS_AND_CONDITIONS =
  '/self-serve-content/terms-and-conditions/temporary-suspension';

// STORAGE keys
export const DEEPLINK_STORAGE_KEY = 'ute.rci.deep.link.url';
export const GUID_KEY = 'guid';
export const ACCOUNT_NUMBER = 'accountNumber';
export const ACCOUNT_ALIAS = 'accountAlias';
export const PHONE_NUMBER = 'phoneNumber';
export const SUBSCRIPTION_ALIAS = 'subscriptionAlias';
export const SELECTED_SUBSCRIBER_NUMBER = 'selectedSubscriberNo';
export const AAL_ELIGIBLE_DATA = 'aalEligibleData';

// HEADERS
export const X_APP_ID_HEADER = 'x-app-id';
export const X_APP_ID_HEADER_VALUE = 'Fido.ca';
export const X_APP_ID_HEADER_VALUE_2 = 'FIDOWEB';

export const X_APP_NAME_HEADER = 'x-app-name';
export const X_APP_NAME_HEADER_VALUE = 'Fido-Web';
export const X_TRANSACTION_ID_HEADER = 'x-transaction-id';

export const REALM = 'FIDO';

export const RESPONSIVE_CONFIG = {
  breakPoints: {
    xs: { max: 599.98 },
    sm: { min: 600, max: 899.98 },
    md: { min: 900, max: 1199.98 },
    lg: { min: 1200, max: 1919.98 },
    xl: { min: 1920 },
  },
  debounceTime: 100,
};

export const CMS_CONTENT_URL = '/html-fido/cms/content/ute/fido/views/';
export const PICKUP_HELP_URL = 'https://www.fido.ca/support/mobility/what-you-need-to-know-about-express-pickup';

// BRT switch IDs
export const BANK_PAYMENT_ID_BRT_SWITCH = 'FIDO_BANK_PAYMENT_ID';
export const PROMOTIONS_URL = '/promotions?icid=F_WIR_ALD_LQ18G9';
export const FIDO_PAY_OFF_BALANCE = 'FIDO_PAY_OFF_BALANCE';
export const NEW_OFFERS_API = 'FIDO_NEW_OFFERS_API';
